
// 判断是否是管理页面
export const isAdminstator = false;


export const imMsgStateMap = {
  undefined: 'success',
  0: 'hide',   // 隐藏
  1: 'success',   // 显示
  2: 'delete',   // 删除
}
